const BreadCrumbUpperCaseTokens = ["emr"];

export default BreadCrumbUpperCaseTokens;
